/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCoinPound = createReactComponent("coin-pound", "IconCoinPound", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M15 9a2 2 0 1 0 -4 0v5a2 2 0 0 1 -2 2h6", key: "svg-1" }],
  ["path", { d: "M9 12h4", key: "svg-2" }]
]);

export { IconCoinPound as default };
//# sourceMappingURL=IconCoinPound.js.map
